import AppState from '../../AppState';
import { planSvgUnchecked, premiumSpeed, standardPlusSpeed, standardSpeed, superFastSpeed, ultraFastSpeed, } from '../helperFunctions';
import getNodePlanFeatures from '../getNodePlanFeatures';
/**
 * Builds and displays a plan tile.
 *
 * @param {HTMLElement} plan - The HTML element representing the plan tile container.
 * @param {string} name - The name of the plan.
 * @param {string} nameId - The name based ID to trigger modal.
 * @param {string} planId - The id of the plan.
 * @param {number} price - The price of the plan.
 * @param {number} discount - The discount amount of the plan.
 * @param {number} min_cost - The minimum cost of the plan.
 * @param {number} download - The download speed of the plan.
 * @param {number} upload - The upload speed of the plan.
 * @param {string} icon - The icon to indicate if plan is selected (default: planSvgUnchecked).
 * @returns {void}
 */
export const onePlatformBuildPlanTileDisplay = (plan, name, nameId, planId, price, discount, min_cost, download, upload, icon = planSvgUnchecked) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { Drupal } = drupalJsObjects;
    let priceDisplay = `<div class="cost"><span>$${price}</span>/mth</div>`;
    if (discount > 0) {
        priceDisplay = `
      <div class="discount">Was <span>$${price}</span>/mth</div>
      <div class="cost"><span>$${discount}</span>/mth</div>
    `;
    }
    plan.innerHTML = `
    <header>
      <h3 class="plan-name">${name}</h3>
      <div class="plan-radio">${icon}</div>
    </header>
    <div class="service-plans--service-plan--body">
      <ul id="offer-badges-${planId}" class="badges"></ul>
      ${priceDisplay}
      <div class="text">${Drupal.t('Includes a free Wi-Fi 6 modem, plus unlimited data on a month-to-month plan.')}</div>
      <div class="speed">${download}mbps download & ${upload}mbps upload typical evening speeds</div>
      <div class="details"><a href="#" data-bs-toggle="modal" data-bs-target="#plan-modal-${nameId}">${Drupal.t('More info')}</a></div>
      <div id="terms-condition-${planId}" class="terms-conditions">
        <p>${Drupal.t('Total Minimum Cost')} <span>$${min_cost}</span></p>
        <p>${Drupal.t('Terms and conditions apply')} &ndash; <a href="#" data-bs-toggle="modal" data-bs-target="#terms-modal-${nameId}">${Drupal.t('Learn more')}</a></p>
      </div>
    </div>
  `;
};
/**
 * Builds the "View Details" modal for plan tile.
 *
 * @param {PlanData} planData - The data of the plan.
 * @param {string} nameId - Used to construct modal id .
 * @param {number} price - The price of the plan.
 * @param {number} discount - The discount applied to the plan (if any).
 * @param {NodeItem} promoDetails - The promo detail paragraph.
 */
export const onePlatformBuildPlanModalDisplay = (planData, nameId, price, discount, promoDetails) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { context } = drupalJsObjects;
    const responseData = planData['data'];
    if (responseData) {
        let attributes;
        if (Array.isArray(responseData)) {
            attributes = responseData[0]['attributes'];
        }
        else if (typeof responseData === 'object') {
            attributes = responseData['attributes'];
        }
        if (attributes) {
            const { field_plan_id, title, field_plan_speed_download, field_plan_speed_upload, field_plan_callout_text, field_plan_end_date, field_plan_information, field_plan_documents } = attributes;
            if (context.getElementById(`plan-modal-${nameId}`)) {
                context.getElementById(`plan-modal-${nameId}`).remove();
            }
            const modal = document.createElement('div');
            modal.classList.add('address-modal', 'modal', 'fade');
            modal.setAttribute('id', `plan-modal-${nameId}`);
            modal.setAttribute('tabindex', '-1');
            modal.setAttribute('aria-labelledby', `plan-modal-${nameId}-label`);
            modal.setAttribute('aria-hidden', 'true');
            let planSvg;
            switch (field_plan_id) {
                case 'SBCHRG7':
                case 'SBCHRG10':
                    planSvg = standardPlusSpeed;
                    break;
                case 'SBCHRG8':
                    planSvg = premiumSpeed;
                    break;
                case 'SBCHRG9':
                    planSvg = superFastSpeed;
                    break;
                case 'SBCHRG11':
                    planSvg = ultraFastSpeed;
                    break;
                default:
                    planSvg = standardSpeed;
            }
            let priceDisplay = `<div class="cost"><span>$${price}</span>/mth</div>`;
            if (discount > 0) {
                priceDisplay = `
          <div class="cost">
            <div class="discount">Was $${price}/mth</div>
            <span>$${discount}</span>/mth
          </div>
        `;
            }
            let calloutText = '';
            if (field_plan_callout_text !== null) {
                calloutText = `
          <p>
            <strong>Also includes:</strong>
          </p>
          <p class="primus-success badge">
            ${field_plan_callout_text}
          </p>
        `;
                if (field_plan_end_date !== null) {
                    calloutText += `
            <ul class="mb-0">
              <li>
                Offer ends ${field_plan_end_date}
              </li>
            </ul>
          `;
                }
            }
            modal.innerHTML = `
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body container">
              <div class="row">
                <div class="col-sm-12 col-lg-6 address-modal__wrapper">
                  <h3 class="address-modal__title">${title}</h3>
                  <div class="address-modal__cost-speed">
                    ${priceDisplay}
                    <div class="speed">${planSvg}</div>
                  </div>
                  <div class="address-modal__text-box">
                    <p>
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                          <g clip-path="url(#clip0_3764_16905)">
                            <path d="M5.40812 12.5503C7.38469 10.9039 9.87573 10.0024 12.4481 10.0024C15.0205 10.0024 17.5116 10.9039 19.4881 12.5503M1.82812 9.00028C4.75055 6.42425 8.51242 5.00293 12.4081 5.00293C16.3038 5.00293 20.0657 6.42425 22.9881 9.00028M8.93812 16.1103C9.95333 15.389 11.1678 15.0015 12.4131 15.0015C13.6585 15.0015 14.8729 15.389 15.8881 16.1103M12.4081 20.0003H12.4181" stroke="#2653F5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_3764_16905">
                              <rect width="24" height="24" fill="white" transform="translate(0.40625)"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </p>
                    ${field_plan_speed_download}/${field_plan_speed_upload} Mbps typical busy period speeds (7pm-11pm)</div></p>
                    <ul id="featured-list" class="dynamic-checked-items"></ul>
                </div>
                <div class="col-sm-12 col-lg-6 address-modal__wrapper">
                  <h4 class="address-modal__sub-title">More info</h4>
                  <div class="address-modal__segment">
                    ${calloutText}
                    ${field_plan_information.value}
                  </div>
                  <ul id="plan-documents" class="address-modal__segment"></ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
            // Update documents from matching Plan details paragraph.
            let planDocuments;
            if (promoDetails && promoDetails.attributes.field_promo_detail_documents) {
                planDocuments = promoDetails.attributes.field_promo_detail_documents;
            }
            else if (field_plan_documents) {
                planDocuments = field_plan_documents;
            }
            if (planDocuments) {
                onePlatformBuildDocumentsDisplay(planDocuments, modal);
            }
            getNodePlanFeatures(planData, modal);
            context.querySelector('#content').appendChild(modal);
        }
    }
};
/**
 * Builds the "Terms and Conditions" modal.
 *
 * @param {string} nameId - Used to construct modal id.
 * @param {string} title - The plan name.
 * @param {string} terms - The terms and conditions content as HTML string.
 */
export const onePlatformBuildTermsModalDisplay = (nameId, title, terms) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { Drupal, context } = drupalJsObjects;
    if (context.getElementById(`terms-modal-${nameId}`)) {
        context.getElementById(`terms-modal-${nameId}`).remove();
    }
    const modal = document.createElement('div');
    modal.classList.add('terms-modal', 'modal', 'fade');
    modal.setAttribute('id', `terms-modal-${nameId}`);
    modal.setAttribute('tabindex', '-1');
    modal.setAttribute('aria-labelledby', `terms-modal-${nameId}-label`);
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
        <div class="tab-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M1 10H23M3 4H21C22.1046 4 23 4.89543 23 6V18C23 19.1046 22.1046 20 21 20H3C1.89543 20 1 19.1046 1 18V6C1 4.89543 1.89543 4 3 4Z" stroke="#2653F5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body container">
          <div class="row">
            <div class="col-12">
              <h3>${Drupal.t('Terms and conditions')} &ndash; ${title}</h3>
              ${terms}
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
    context.querySelector('#content').appendChild(modal);
};
/**
 * Builds the display for the Key Documents field with modal.
 *
 * @param {DocumentsField[]} documentsData - Array of document fields.
 * @param {HTMLElement} modal - The modal to attach the data to.
 * @returns {void}
 */
export const onePlatformBuildDocumentsDisplay = (documentsData, modal) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { Drupal, settings } = drupalJsObjects;
    const { baseUrl } = settings;
    documentsData.forEach(doc => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        if (doc.uri.startsWith('internal:')) {
            const path = doc.uri.replace('internal:/', '');
            a.href = baseUrl + Drupal.url(path);
        }
        else if (doc.uri.startsWith('entity:')) {
            const entityId = doc.uri.replace('entity:node/', '');
            a.href = Drupal.url(`node/${entityId}`);
        }
        a.innerText = doc.title;
        a.target = '_BLANK';
        li.appendChild(a);
        modal.querySelector('#plan-documents').appendChild(li);
    });
};
